import { Window } from '../../ui/Window';

interface OncallNoticeWindowProps {
  onClose: () => void;
}

export function OncallNoticeWindow({ onClose }: OncallNoticeWindowProps) {
  return (
    <Window title="ONS" onClose={onClose} width={600} height={500}>
      <div className="p-2">
        <p className="mt-10">
          Hi, Trent, this is my last day in Laura.ai. Im leaving this note here
          in case you think they killed me. Also please dont trust anyone here,
          especially dont talk in the coffee room. If you have to talk, you can
          only trust Tina from HR.
        </p>
      </div>
    </Window>
  );
}
